import http from "./httpRequest";
import filesService from "./files.service";
import { CertificateRequest } from "../models/CertificateRequest";
import {HttpStatusCode} from "../models/HttpStatusCodes";
import {AlertTypes} from "../models/Enums";

class ExportsService {
	async downloadProjectDataCSV() {
		const response = await http.get("exports/exportAllData", {
			responseType: 'blob',
		});

		if (response.status === HttpStatusCode.NoContent) {
			http.apiResponse.showError("[204] No projects were found in current period.", AlertTypes.WARNING);
			return;
		}

		if (response.status !== HttpStatusCode.Ok) {
			return;
		}
		filesService.processFileToDownload(response, 'projects_data.csv');
	}
		
	async generateAndDownloadCertificates(data: CertificateRequest) {
		let response = await http.post(`/certificates/generateZipFile`, data, {
			responseType: 'blob'
		});

		if (response.status === HttpStatusCode.NoContent) {
			http.apiResponse.showError("[204] No Advisors were found in current period.", AlertTypes.WARNING);
			return;
		}

		if (response.status !== 200) {
			return;
		}

		filesService.processFileToDownload(response, 'Certificates.zip');
	}
}

export default new ExportsService();